export default __webpack_public_path__ + "static/media/Home.1eab40e5.svg";